// extracted by mini-css-extract-plugin
export default {"label":"NewEditorButton_label__FtQ7J"};